import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { status } from 'constants/general';
import companiesStrings from 'modules/companies/strings';
import CompaniesHeader from 'modules/companies/components/CompaniesHeader';
import CompaniesFilter from 'modules/companies/components/CompaniesFilter';
import CompaniesList from 'modules/companies/components/CompaniesList';
import Loader from 'modules/common/components/Loader';
import Pagination from 'modules/common/components/Pagination';

import {
  CompaniesWrapper,
  LoaderWrapper,
  NoResultsWrapper,
  NoResultsText,
  PaginationWrapper,
} from './CompaniesComponent.style';

const CompaniesComponent = ({
  searchQuery,
  selectedPageFilter,
  handleAddCompanyBtnClick,
  handleSearchBarInputChange,
  handleCompaniesPaginationClick,
  handleCompanyClick,
}) => {
  const { companyProfilesList } = useSelector(state => ({
    companyProfilesList: state.common.companyProfilesList,
  }));

  const totalResultsCount = companyProfilesList?.details?.totalCount;
  const numberOfPages = (totalResultsCount && Math.ceil(totalResultsCount / 12)) || 1;
  const companiesListArr = companyProfilesList?.details?.results;

  const renderCompaniesList = () => {
    if (
      companyProfilesList.status === status.SHOULD_CALL_API ||
      companyProfilesList.status === status.FETCHING
    )
      return (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      );

    if (companyProfilesList.status === status.SUCCESS && companiesListArr?.length > 0)
      return (
        <>
          <CompaniesList
            companiesListArr={companiesListArr}
            handleCompanyClick={handleCompanyClick}
          />
          {numberOfPages > 1 && (
            <PaginationWrapper>
              <Pagination
                currentPage={selectedPageFilter}
                totalCount={numberOfPages}
                handlePaginationClick={handleCompaniesPaginationClick}
              />
            </PaginationWrapper>
          )}
        </>
      );

    return (
      <NoResultsWrapper>
        <NoResultsText>{companiesStrings.companiesList.companiesGridNoResultsFound}</NoResultsText>
      </NoResultsWrapper>
    );
  };

  return (
    <>
      <CompaniesHeader handleAddCompanyBtnClick={handleAddCompanyBtnClick} />
      <CompaniesWrapper>
        <CompaniesFilter
          searchQuery={searchQuery}
          handleSearchBarInputChange={handleSearchBarInputChange}
        />
        {renderCompaniesList()}
      </CompaniesWrapper>
    </>
  );
};

CompaniesComponent.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  selectedPageFilter: PropTypes.number.isRequired,
  handleAddCompanyBtnClick: PropTypes.func.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  handleCompaniesPaginationClick: PropTypes.func.isRequired,
  handleCompanyClick: PropTypes.func.isRequired,
};

export default CompaniesComponent;
